import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportContact = () => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
            <Icon name="HelpCircle" className="w-6 h-6 text-blue-600" />
          </div>
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Need Help?
          </h3>
          <p className="text-gray-600 mb-3">
            If you're experiencing issues with email verification or haven't received the email after several attempts, our support team is here to help.
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <a
              href="mailto:support@mybodytoday1.com"
              className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium"
            >
              <Icon name="Mail" className="w-4 h-4 mr-2" />
              Email Support
            </a>
            <span className="text-sm text-gray-500">
              support@mybodytoday1.com
            </span>
          </div>
          <p className="text-xs text-gray-500 mt-3">
            Our support team typically responds within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupportContact;